import { gql } from '@apollo/client';
import type { FrameioShareVideos } from '@/queries/frameio';

// Hand-written types: production introspection is disabled. The backend
// returns the same shape as frameioShareVideos, so the picker and batch import
// are shared.
export type MediasiloReviewVideos = FrameioShareVideos;
export type MediasiloReviewVideosQuery = { mediasiloReviewVideos: MediasiloReviewVideos };
export type MediasiloReviewVideosQueryVariables = { url: string };

export const MEDIASILO_REVIEW_VIDEOS = gql`
  query MediasiloReviewVideos($url: String!) {
    mediasiloReviewVideos(url: $url) {
      share_name
      truncated
      videos {
        asset_id
        name
        duration_seconds
        width
        height
        thumbnail_url
        canonical_url
      }
    }
  }
`;
